import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * ログアウトAPI
 * @param  {} params={}
 */
export const logout = (params = {}) => {
  const defaults = {
    _path: 'CM/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * サジェスト一覧API
 * @param  {} params={}
 */
export const listSuggest = (params = {}) => {
  const defaults = {
    _path: 'CM/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * ファイル取得API
 * @param  {} params={}
 */
export const fetchFile = (params = {}) => {
  const defaults = {
    _path: 'CM/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  // return axios.post(API_RELAY_PATH, { params: r, responseType: 'arraybuffer' })
  return axios.post(API_RELAY_PATH, r, { responseType: 'arraybuffer' })
}

/**
 * ファイル取得APIのURLを取得する
 * 【用途】
 *  QA詳細画面でPDFを表示する
 *  書式DL画面で書式のリンクを生成する
 * @param {numeric} fileId ファイルID
 * @param {boolean} isDownload ダウンロードフラグ(Content-Disposition: attach を付与する場合はtrue)
 */
export const getFetchFileAPIURL = (fileId, isDownload = false) => {
  const download = isDownload ? 1 : 0
  return API_RELAY_PATH + '?_path=' + encodeURIComponent('CM/003') + '&file_id=' + fileId + '&token=' + encodeURIComponent(store.state.auth.token) + '&download=' + encodeURIComponent(download)
}

/**
 * 利用者設定取得API
 * @param  {} params={}
 */
export const fetchUserSetting = (params = {}) => {
  const defaults = {
    _path: 'CM/004',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 利用者設定更新API
 * @param  {} params={}
 */
export const updateUserSetting = (params = {}) => {
  const defaults = {
    _path: 'CM/005',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }
  // 設定値がオブジェクトの場合は、文字列に変換して送信
  r.setting_value = typeof r.setting_value === 'object'
    ? JSON.stringify(r.setting_value)
    : r.setting_value

  return axios.post(API_RELAY_PATH, r)
}

/**
 * トークンリフレッシュAPI
 * @param  {} params={}
 */
export const refreshToken = (params = {}) => {
  const defaults = {
    _path: 'CM/006',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * マスター取得API
 * @param  {} params={}
 */
export const fetchMaster = (params = {}) => {
  const defaults = {
    _path: 'CM/007',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}


/**
 * マスター取得API
 * @param  {} params={}
 */
export const fetchKnowledfeAuthFile = (filePath) => {
  // const defaults = {
  //   _path: 'CM/009',
  //   token: store.state.auth.token
  // }

  // const r = { ...defaults, ...params }

  return API_RELAY_PATH + '?_path=' + encodeURIComponent('CM/009') + '&file_path=' + filePath + '&token=' + encodeURIComponent(store.state.auth.token)


  // return axios.post(API_RELAY_PATH, r)
}

